import { render, staticRenderFns } from "./ContactDetail.vue?vue&type=template&id=38596bdc&scoped=true&"
import script from "./ContactDetail.vue?vue&type=script&lang=js&"
export * from "./ContactDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38596bdc",
  null
  
)

export default component.exports